var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCautionSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "caution-svgrepo-com 1",
    clipPath: "url(#clip0_1440_3934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.0064 39.7405C23.1375 39.7405 21.6172 41.2634 21.6172 43.1364C21.6172 45.0094 23.1375 46.5337 25.0064 46.5337C26.8753 46.5337 28.3956 45.0107 28.3956 43.1364C28.3956 41.2648 26.8753 39.7405 25.0064 39.7405ZM25.0064 45.1824C23.8821 45.1824 22.9685 44.2648 22.9685 43.1364C22.9685 42.008 23.8821 41.0918 25.0064 41.0918C26.1307 41.0918 27.0442 42.0094 27.0442 43.1364C27.0442 44.2634 26.1307 45.1824 25.0064 45.1824Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.0058 15.1353C22.7707 15.1353 20.9518 16.8447 20.9531 18.9866L21.8383 33.9001C21.8383 35.4758 23.1964 36.7582 24.8653 36.7582C26.5342 36.7582 27.8923 35.4758 27.8896 33.9528L29.0599 18.9461C29.0599 16.8447 27.241 15.1353 25.0058 15.1353ZM26.541 33.8988C26.541 34.7298 25.7896 35.4055 24.8653 35.4055C23.941 35.4055 23.1896 34.7298 23.1883 33.8582L22.3031 18.9461C22.3031 17.5907 23.5153 16.4866 25.0058 16.4866C26.4964 16.4866 27.7085 17.5893 27.7099 18.8934L26.541 33.8988Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.85579 43.919H16.8058C17.1788 43.919 17.4815 43.6163 17.4815 43.2433C17.4815 42.8703 17.1788 42.5676 16.8058 42.5676H4.85579C3.54633 42.5676 2.39497 41.8865 1.77606 40.7446C1.16795 39.623 1.22065 38.3136 1.91795 37.2433L22.0652 6.31355C22.7112 5.32166 23.8098 4.72977 25.0031 4.72977C26.1963 4.72977 27.295 5.32166 27.9409 6.31355L48.0882 37.2433C48.7855 38.3136 48.8382 39.623 48.2301 40.7446C47.6112 41.8865 46.4598 42.5676 45.1504 42.5676H33.2004C32.8274 42.5676 32.5247 42.8703 32.5247 43.2433C32.5247 43.6163 32.8274 43.919 33.2004 43.919H45.1504C46.9639 43.919 48.5585 42.973 49.4179 41.3879C50.2666 39.823 50.1923 37.9973 49.2207 36.5041L29.0734 5.57572C28.1774 4.19869 26.6558 3.37842 25.0031 3.37842C23.3504 3.37842 21.8288 4.20004 20.9328 5.57572L0.785515 36.5054C-0.187458 37.9987 -0.260431 39.8244 0.588218 41.3892C1.44633 42.973 3.04227 43.919 4.85579 43.919Z",
    fill: "#E30613"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1440_3934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionSvgrepoCom1);
export default __webpack_public_path__ + "static/media/caution-svgrepo-com 1.aa950acbd77020bc1bb97ace188990fd.svg";
export { ForwardRef as ReactComponent };